<div class="bar" *ngFor="let bar of bars; index as i" [class.bar--active]="bar" [ngStyle]="{ height: ((i + 1) * 10) + '%' }"></div>
